import { CONTACTS, LOGO_URL } from "@/lib/data";
import { Instagram, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] pt-24 md:pt-32 pb-10 border-t border-white/10 overflow-hidden"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        {/* Big logo mark */}
        <div className="flex justify-center mb-20">
          <img
            src={LOGO_URL}
            alt="Flyora Weddings"
            data-testid="footer-logo"
            className="h-48 md:h-64 w-auto object-contain [mix-blend-mode:screen]"
          />
        </div>
        {/* Contact blocks */}
        <div
          data-testid="contact-blocks"
          className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-20 mb-24"
        >
          {CONTACTS.map((c, i) => (
            <div key={i} data-testid={`contact-${c.territory.toLowerCase()}`}>
              <div className="flex items-center gap-3 mb-6">
                <span className="w-8 h-px bg-[#C4A484]" />
                <span className="font-mono-label text-[10px] text-[#C4A484]">
                  Studio · 0{i + 1}
                </span>
              </div>
              <h3 className="font-heading text-4xl md:text-5xl tracking-tighter mb-2">
                {c.territory}
              </h3>
              <p className="font-mono-label text-[10px] text-[#8F8F8F] mb-6">
                {c.country}
              </p>
              <div className="space-y-3 text-sm text-[#FDFBF7]/80">
                <div>
                  <a
                    href={`tel:${c.phone.replace(/\s/g, "")}`}
                    className="link-underline"
                  >
                    {c.phone}
                  </a>
                </div>
                <div>
                  <a href={`mailto:${c.email}`} className="link-underline">
                    {c.email}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Massive FLYORA text (kept as editorial signature) */}
        <div className="mb-16 overflow-hidden">
          <h2
            aria-hidden
            className="font-heading text-[24vw] md:text-[16vw] leading-[0.85] tracking-tighter text-[#FDFBF7]/90 select-none text-center"
          >
            FLYORA
          </h2>
          <p className="text-center font-mono-label text-[10px] text-[#C4A484] tracking-[0.4em] -mt-2">
            CINEMATIC LOVE STORIES
          </p>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div className="font-mono-label text-[10px] text-[#8F8F8F]">
            © {new Date().getFullYear()} FLYORA WEDDINGS · A FLYFILMS PRODUCTION
          </div>
          <div className="flex items-center gap-6">
            <a
              href="https://instagram.com/flyora_weddings"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram"
              className="text-[#FDFBF7]/70 hover:text-[#C4A484] transition-colors"
              aria-label="Instagram"
            >
              <Instagram size={18} />
            </a>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-youtube"
              className="text-[#FDFBF7]/70 hover:text-[#C4A484] transition-colors"
              aria-label="YouTube"
            >
              <Youtube size={18} />
            </a>
            <span className="font-mono-label text-[10px] text-[#8F8F8F]">
              INDIA · DUBAI · LONDON
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
